import requestAction from '../../utils/requestAction'

export const fetchHistoryGroupClasses = (params: string = "", prefix = '') =>
  requestAction('HISTORY_GROUP_CLASS_LIST', params)(`${prefix}classes`, 'GET')
